/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:02:34
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/radio.js
 */
export default {
    // radio组件
    radio: {
        name: '',
        shape: '',
        disabled: '',
        labelDisabled: '',
        activeColor: '',
        inactiveColor: '',
        iconSize: '',
        labelSize: '',
        label: '',
        labelColor: '',
        size: '',
        iconColor: '',
        placement: ''
    }
}
